import React, { useState } from 'react'
import { Column } from 'primereact/column'
import { Link } from 'react-router-dom'
import { PrimeIcons } from 'primereact/api'

import { Table } from '../../../common/uikit/Table'
import { ApplicationLog, useLogGetErrorsQuery } from '../../../common/redux/api/web-api'
import { dateLocalize } from '../../../lib/date-localize'
import { Input } from '../../../common/uikit/Input'
import useText from '../../../common/hooks/useText'

export const LatestErrorWidget = () => {
    const text = useText()
    const [searchFilter, setSearchFilter] = useState('')
    const { data: latestErrors, isLoading: loadingErrors } = useLogGetErrorsQuery({ noOfItems: 100 })

    return (
        <div className="flex flex-column gap-5">
            <Input
                id="error-search-input"
                type="search"
                onChange={(e) => setSearchFilter(e.target.value)}
                placeholder={text('msgSearch')}
                icon={PrimeIcons.SEARCH}
                name="searchFilter"
                data-testid="error-search-input"
            />
            <Table
                value={latestErrors ?? []}
                size="normal"
                removableSort
                loading={loadingErrors}
                globalFilter={searchFilter}
                globalFilterFields={['message']}
                dataKey="id"
                paginator
                rows={10}
                emptyMessage={text('msgNoErrorsFound')}
                data-testid="error-table"
            >
                <Column
                    field="chargePointId"
                    header={text('lblSerialNumber')}
                    body={(log: ApplicationLog) => {
                        return (
                            <Link className="pr-4" to={`/chargepoints/${log.chargePointId}`}>
                                {log.chargePointId}
                            </Link>
                        )
                    }}
                ></Column>
                <Column
                    field="timestamp"
                    header={text('lblTimestamp')}
                    body={(latestError) => dateLocalize(latestError.timestamp)}
                ></Column>
                <Column field="message" header={text('lblMessage')} className="w-4"></Column>
                <Column field="origin" header={text('lblOrigin')}></Column>
            </Table>
        </div>
    )
}
